import { useState } from "react";
import { Share2, Bell, Mail } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function TripToolbar() {
  const { user, setUser } = useAuth();
  const [perm, setPerm] = useState("Notification" in window ? Notification.permission : "unsupported");

  const share = async () => {
    try {
      const { data } = await api.post("/itinerary/share");
      const url = `${window.location.origin}/share/${data.token}`;
      if (navigator.share) await navigator.share({ title: "My VacaVibe trip", url }).catch(() => {});
      else { await navigator.clipboard.writeText(url); }
      toast.success("Trip link ready", { description: url });
    } catch (e) { toast.error(errorMessage(e)); }
  };

  const toggleEmail = async (on) => {
    try { const { data } = await api.patch("/auth/preferences", { email_reminders: on }); setUser(data); }
    catch (e) { toast.error(errorMessage(e)); }
  };

  const enablePopups = async () => {
    const p = await Notification.requestPermission();
    setPerm(p);
    if (p === "granted") toast.success("Pop-up reminders are on");
    else toast.error("Pop-ups are blocked — allow notifications in your browser settings");
  };

  return (
    <div className="mt-8 flex flex-wrap items-center gap-3">
      <Button data-testid="trip-share-button" onClick={share} className="rounded-full bg-[#FF3B6B] hover:bg-[#E02E5A] text-white font-semibold">
        <Share2 className="h-4 w-4 mr-1.5" /> Share my trip
      </Button>
      <label className="flex items-center gap-2 rounded-full border border-[#26334D] px-4 py-2 text-sm text-slate-300">
        <Mail className="h-4 w-4 text-[#00E5A3]" /> Email reminders
        <Switch data-testid="trip-email-reminders" checked={user.email_reminders !== false} onCheckedChange={toggleEmail} />
      </label>
      {perm !== "unsupported" && (
        perm === "granted"
          ? <span data-testid="trip-popups-on" className="flex items-center gap-2 text-sm text-[#00E5A3]"><Bell className="h-4 w-4" /> Pop-up reminders on</span>
          : <Button data-testid="trip-enable-popups" variant="outline" onClick={enablePopups} className="rounded-full border-[#26334D] bg-transparent"><Bell className="h-4 w-4 mr-1.5" /> Turn on pop-up reminders</Button>
      )}
    </div>
  );
}
